import { render } from "./ChatWindow.vue?vue&type=template&id=f095b812&scoped=true&ts=true"
import script from "./ChatWindow.vue?vue&type=script&lang=ts"
export * from "./ChatWindow.vue?vue&type=script&lang=ts"

import "./ChatWindow.vue?vue&type=style&index=0&id=f095b812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f095b812"],['__file',"src/components/AIChat/ChatWindow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f095b812"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f095b812', __exports__)) {
    api.reload('f095b812', __exports__)
  }
  
  module.hot.accept("./ChatWindow.vue?vue&type=template&id=f095b812&scoped=true&ts=true", () => {
    api.rerender('f095b812', render)
  })

}


export default __exports__